// extracted by mini-css-extract-plugin
export default {"KeyboardRow":"KeyboardRow_KeyboardRow__gi3El"};